/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * List of supported image families (OSes) for EKS.   - FAMILY_AL2: Amazon Linux 2 (https://aws.amazon.com/amazon-linux-2/).  - FAMILY_AL2023: Amazon Linux 2023 (https://aws.amazon.com/linux/amazon-linux-2023/).  - FAMILY_BOTTLEROCKET: Bottlerocket (https://aws.amazon.com/bottlerocket/).
 * @export
 * @enum {string}
 */

export const NodeconfigV1EKSConfigImageFamily = {
    FAMILY_UNSPECIFIED: 'FAMILY_UNSPECIFIED',
    FAMILY_AL2: 'FAMILY_AL2',
    family_al2: 'family_al2',
    FAMILY_AL2023: 'FAMILY_AL2023',
    family_al2023: 'family_al2023',
    FAMILY_BOTTLEROCKET: 'FAMILY_BOTTLEROCKET',
    family_bottlerocket: 'family_bottlerocket'
} as const;

export type NodeconfigV1EKSConfigImageFamily = typeof NodeconfigV1EKSConfigImageFamily[keyof typeof NodeconfigV1EKSConfigImageFamily];



